var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/student",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 11.7857143,
    cy: 11.7857143,
    r: 11.7857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24562354,12.5563856 C8.46259255,12.5563856 8.63848068,12.7322738 8.63848068,12.9492428 C8.63848068,13.1662118 8.46259255,13.3420999 8.24562354,13.3420999 C8.02865453,13.3420999 7.8527664,13.1662118 7.8527664,12.9492428 C7.8527664,12.7322738 8.02865453,12.5563856 8.24562354,12.5563856",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3315429,12.5563856 C15.5485119,12.5563856 15.7244,12.7322738 15.7244,12.9492428 C15.7244,13.1662118 15.5485119,13.3420999 15.3315429,13.3420999 C15.1145739,13.3420999 14.9386857,13.1662118 14.9386857,12.9492428 C14.9386857,12.7322738 15.1145739,12.5563856 15.3315429,12.5563856",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01430857,0.590270284 C9.25123817,3.88698296 11.1958734,6.11381316 13.8482143,7.27076088 C16.5005552,8.4277086 19.4450885,8.49190974 22.6818143,7.46336431",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.0382697 C2.6482102,10.3722684 4.65992532,9.27650342 6.03514536,7.75097472 C7.4103654,6.22544602 8.32179464,4.42750207 8.76943307,2.35714286",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStudent);
export default __webpack_public_path__ + "static/media/menu-student.27ea7bb537164e60578cea610f8bae54.svg";
export { ForwardRef as ReactComponent };